import { Button, ButtonProps } from '@material-ui/core';
import React from 'react';
import useToggle from '../Hooks/useToggle';
import ConfirmOperation from './ConfirmOperation';
interface DiscardButtonWithConfirmationProps extends ButtonProps {
    dataItem?: any;
    message?: string;
    isLoading: boolean;
    onDiscardConfirmed: any;
    children?: JSX.Element;
}

const DiscardButtonWithConfirmation: React.FC<DiscardButtonWithConfirmationProps> = ({
    dataItem,
    message,
    isLoading,
    onDiscardConfirmed,
    children,
    ...props
}) => {
    const [open, toggleOpen] = useToggle(false);

    return (
        <>
            <Button
                variant="contained"
                className={props.className}
                onClick={toggleOpen}
                color={props.color}
                style={props.style}
                size={props.size}
                {...props}
            >
                {children}
            </Button>
            {open && (
                <ConfirmOperation
                    message={message ? message : ''}
                    isLoading={isLoading}
                    onClose={toggleOpen}
                    operation={() => {
                        onDiscardConfirmed(dataItem);
                    }}
                />
            )}
        </>
    );
};

export default DiscardButtonWithConfirmation;
